import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import BaseAntiBot from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAntiBot';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {antiBotIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.antiBot;
const pageId = pageSchema.pageId;

function GatewayAntiBot({
    gatewayObject,
    planObject,
    setGatewayData,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);
    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.ANTI_BOT')}
            icon={antiBotIcon}
        >
            <BaseAntiBot
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                setEditorPageId={setEditorPageId}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.ThreatPreventionActivation')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.THREAT_PREVENTION')}</SMCLink>
        </Indentation>
        </>
    );
}

export default GatewayAntiBot;